<template>
  <v-dialog v-model="dialog" scrollable persistent width="950px">
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-card flat tile color="white">
      <v-card-title class="dialog-header-title pr-2">
        <v-row no-gutters>
          <v-col>
            <span class="title font-weight-bold white--text">New Message</span>
          </v-col>

          <v-col cols="1" class="d-flex justify-content-end">
            <v-icon size="30" color="white" @click="onDialogClose">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="pt-6">
        <v-row no-gutters>
          <v-col cols="4">
            <v-text-field
              label="From:"
              dense
              class="em-text-field body-2 blue-grey--text"
              outlined
              v-model="mailMessage.from"
              disabled
            ></v-text-field>
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="7">
            <v-text-field
              label="To:"
              dense
              class="em-text-field body-2 primary--text"
              outlined
              v-model="mailMessage.to"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="6">
            <v-text-field
              label="Cc:"
              dense
              class="em-text-field body-2 primary--text"
              outlined
              v-model="mailMessage.cc"
            ></v-text-field>
          </v-col>

          <v-spacer></v-spacer>

          <v-col cols="5">
            <v-text-field
              label="Bcc:"
              dense
              class="em-text-field body-2 primary--text"
              outlined
              v-model="mailMessage.bcc"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-text-field
            label="Subject:"
            dense
            class="em-text-field body-2 font-weight-bold primary--text"
            outlined
            v-model="mailMessage.subject"
          ></v-text-field>
        </v-row>

        <v-row>
          <template v-for="(file, ind) in mailMessage.attachments">
            <v-chip
              :key="ind"
              label
              text-color="white"
              color="primary"
              close
              @click:close="onRemoveAttachedFile(ind)"
              class="mr-4 caption font-weight-bold"
              small
              >{{ file.file_name }}</v-chip
            >
          </template>
        </v-row>

        <v-row no-gutters class="pt-3">
          <v-col>
            <vue-editor
              v-model="mailMessage.body"
              :editorToolbar="customToolbar"
            ></vue-editor>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-1"></v-divider>

      <v-card-actions class="mb-2">
        <v-row justify="end" class="px-4">
          <v-btn
            tile
            color="primary"
            text
            class="font-weight-bold body-2 px-3"
            @click="onFileSelection"
          >
            <v-icon size="20" class="pr-2">mdi-file-multiple</v-icon>Attach Files
          </v-btn>
          <v-btn
            tile
            color="primary"
            text
            class="font-weight-bold body-2 px-3"
            @click="onSendEmail"
          >
            <v-icon size="20" class="pr-2">mdi-send</v-icon>SEND
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogFileSelection" width="700px">
      <v-card flat tile color="white">
        <v-card-title class="dialog-header-title"
          >Select file(s) for attachment</v-card-title
        >

        <v-card-text class="pt-4">
          <v-row no-gutters v-for="(file, ind) in selectionFiles" :key="ind">
            <v-col>
              <span class="black--text">{{ file.file_name }}</span>
            </v-col>

            <v-col>
              <span class="black--text">{{ file.file_tags }}</span>
            </v-col>

            <v-col cols="1">
              <v-checkbox
                color="primary"
                v-model="file.selected"
                value
                :disabled="validateFileSelection(file)"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-0"></v-divider>

        <v-card-actions>
          <v-row justify="end" class="pr-4">
            <v-btn
              color="primary"
              class="font-weight-bold body-1"
              tile
              depressed
              @click="onCloseFileSelection"
              >OK</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import constant from "@/const";
import { VueEditor } from "vue2-editor";
export default {
  props: ["dialog", "value", "source", "subject"],
  components: {
    VueEditor,
  },
  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,

      shipment: null,

      selectionFiles: [],

      dialogFileSelection: false,

      mailMessage: {
        from: `${this.$root.username} <${this.$root.useraccount.email}>`,
        to: null,
        cc: null,
        bcc: null,
        subject: null,
        body: null,
        attachments: [],
      },

      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
      ],
    };
  },
  created() {},

  mounted() {},

  watch: {
    dialog: function () {
      if (this.dialog) {
        this.shipment = this.value;
        this.mailMessage.subject = this.subject;
        this.selectionFiles = [];
      }
    },
  },

  methods: {
    /**
     * on file selection
     */
    onFileSelection() {
      this.$root.blockUImsg = "Fetching files..";
      this.$root.blockUIshow = true;

      this.$https
        .get(
          `/api/files/list?category=shipments&shipment_order_id=${this.shipment.shipment_order_id}`
        )
        .then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.selectionFiles = resp.data.data;
            this.dialogFileSelection = true;
          } else {
            console.log(resp.data);
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = resp.data.msg;
          }

          this.$root.blockUIshow = false;
        })
        .catch((err) => {
          console.log(err);
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
          this.$root.blockUIshow = false;
        });
    },

    /**
     * On selected file
     */
    onSelectedFile(file) {
      this.mailMessage.attachments.push(file);
    },

    /**
     * on file selection dialog closed
     */
    onCloseFileSelection() {
      this.dialogFileSelection = false;
      // append this selected files to mail data attachments
      this.selectionFiles.forEach((element) => {
        if (element.selected != null && element.selected) {
          this.mailMessage.attachments.push(element);
        }
      });
    },

    /**
     * Check if file was selected before
     */
    validateFileSelection(file) {
      let status = false;
      this.mailMessage.attachments.forEach((element) => {
        if (element.file_id == file.file_id) {
          status = true;
          return true;
        }
      });
      return status;
    },

    /**
     * On remove an attached file
     */
    onRemoveAttachedFile(index) {
      this.mailMessage.attachments.splice(index, 1);
    },

    /**
     * On Send the email
     */
    onSendEmail() {
      // validate mail data
      if (this.mailMessage.to == null) {
        this.showSnackbar = true;
        this.snackbarColor = "warning";
        this.snackbarMsg = "Please at least one recipient email address";
        return;
      }

      if (this.mailMessage.subject == null) {
        this.showSnackbar = true;
        this.snackbarColor = "warning";
        this.snackbarMsg = "Please provide a subject for this email";
        return;
      }

      this.$root.blockUImsg = "Sending email..";
      this.$root.blockUIshow = true;

      this.$https
        .post(`/api/admin/send_email`, this.mailMessage)
        .then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.$root.blockUIshow = false;
            this.showSnackbar = true;
            this.snackbarColor = "success";
            this.snackbarMsg = resp.data.msg;

            // close the dialog after 2 seconds
            setTimeout(() => {
              this.onDialogClose();
            }, 2000);
          } else {
            console.log(resp.data);
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = resp.data.msg;
            this.$root.blockUIshow = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
          this.$root.blockUIshow = false;
        });
    },

    /**
     * Close the dialog
     */
    onDialogClose() {
      this.$emit("dialog-close");
    },
  },

  computed: {},
};
</script>

<style scoped>
.v-input.v-text-field.em-text-field {
  margin-top: 0px;
  padding-top: 0px;
  border: 0px solid #e0e0e0 !important;
  border-radius: 0px;
}

::v-deep .v-input__slot {
  padding-left: 0px;
  height: calc(2rem);
}
</style>
